import Vue from 'vue'
import App from './App.vue'

import router from './router'
Vue.config.productionTip = false

import windowSizeMixin from '@/mixins/mixin'; //混入-浏览器窗口监听
Vue.mixin(windowSizeMixin);

import store from './store/store';

import eventBus from './eventBus.js'; //消息组件
Vue.prototype.$eventBus = eventBus;

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// 文章详情页
Vue.prototype.$ArticleUrl = 'https://d.drcnet.com.cn/'
Vue.use(ElementUI);
// 移动端引用
import 'vant/lib/index.css';
import { Popup, Button, Icon, Tab, Tabs, ActionSheet, DropdownMenu, DropdownItem, List, Cell, Collapse, CollapseItem } from "vant";
Vue.use(Popup);
Vue.use(Button);
Vue.use(Icon);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(ActionSheet);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(List);
Vue.use(Cell);
Vue.use(Collapse);
Vue.use(CollapseItem);

new Vue({
    render: h => h(App),
    router,
    store
}).$mount('#app')